export const perfectDiaperData = {
  _id: '2644',
  itemType: 'MULTIPLE_ITEMS',
  itemName: 'info_assest_cloth_diaper_page_templet',
  deeplink: null,
  deeplinkValue: null,
  heading: 'PERFECT Diaper For Baby ',
  headingAlignment: 'CUSTOM',
  headingRightIcon: '',
  viewType: 'HORIZONTAL',
  gridSize: 3,
  items: [
    {
      mobileWebImage:
        'https://images.myloapp.in/NestJsUploads/1670476540595-adjustablemobilediaper.webp',
      desktopImage:
        'https://images.myloapp.in/NestJsUploads/1670476540593-adjustabledesktopdiaper.webp',
      heading: 'Can be used from 3 months to 3 years of age',
      subHeading: '',
      textColor: '#547E9A',
      deeplinkValue: '',
      ctaText: '',
      showCta: false,
      itemType: 'BANNER',
    },
    {
      mobileWebImage:
        'https://images.myloapp.in/NestJsUploads/1668770734721-freeforfivehoursmweb.webp',
      desktopImage:
        'https://images.myloapp.in/NestJsUploads/1668770505505-freeforfivehoursdesktop.webp',
      heading: 'Keep your baby dry & rash free for 5 hours.',
      subHeading: '',
      textColor: '#BC7E2B',
      deeplinkValue: '',
      ctaText: '',
      showCta: false,
      itemType: 'BANNER',
    },
    {
      mobileWebImage:
        'https://images.myloapp.in/NestJsUploads/1668770734724-threehundredtimesmweb.webp',
      desktopImage:
        'https://images.myloapp.in/NestJsUploads/1668770734723-threehundredtimesdesktop.webp',
      heading: 'Reuse upto 300+ times & Save ₹20000 every year',
      subHeading: '',
      textColor: '#539867',
      deeplinkValue: '',
      ctaText: '',
      showCta: false,
      itemType: 'BANNER',
    },
  ],
  priority: 3,
  sectionBgImage: '',
  sectionBgImageHi: '',
  sectionBgColorStart: '#ffffff',
  sectionBgColorEnd: '#ffffff',
  objectId: 0,
  contentType: '',
  itemSize: 'SMALL',
  expertCardViewType: 'PRICE_HIGHLIGHTED',
  categoryTagIds: [],
  videoUrlData: {
    isAutoPlay: false,
    mute: false,
    playerType: 'youtube',
    videoUrl: '',
    thumbnailImage: '',
  },
  viewAllCtaDeeplinkValue: null,
  showViewAllCard: false,
  viewAllDeeplink: null,
  viewAllDeeplinkValue: null,
  viewAllBannerImage: null,
  viewAllBannerImageHi: null,
  offerIds: [],
  tagIds: [],
  tagId: null,
  geoCheck: false,
  articleLimit: 10,
  articleTags: [],
  dietChartItem: false,
  extra: {
    utilityData: null,
  },
  clinicServiceType: [],
  htmlText: '',
  createdAt: '2022-09-06T12:38:05.065Z',
  updatedAt: '2022-11-17T09:58:56.809Z',
  __v: 0,
  generalItemBgImage: '',
  generalItemBgImageHi: '',
  headingHi: '',
  subHeading: '',
  subHeadingHi: '',
  ctaText: 'SELECT YOUR DIAPER ',
  spinEligible: [2],
  formPoints: [],
  timerOfferIds: [],
  dsLabel: '',
  isGeneralItem: true,
};

export const data_3d_daiper = {
  itemType: '3d_DAIPER',
};

export const data_stretch_marks = {
  itemType: 'STRECH_MARKS',
};
